// import { CONSTANTES } from '../../config/constantes';
import { PERMISSOES_E_ROTAS } from '../../config/permissoesRotas';

export const MENU = {
  publico: [
    {
      id: 1,
      nome: 'Painel de Indicadores',
      submenus: [
        { id: 1.1, submenu: 'Gráficos', linkTo: 'graficos' },
        // { id: 1.2, submenu: 'Ficha Técnica Indicadores', linkTo: CONSTANTES.DOWNLOAD_FICHA_INDICADORES, linkExterno: true }
      ]
    }
  ],
  privado: [
    {
      id: 2,
      nome: 'Administrador',
      submenus: [
        { id: 2.1, submenu: 'Configurações Gerais', linkTo: 'admin/configuracoes-gerais', acceptedRoles: PERMISSOES_E_ROTAS['configuracoesGerais'] }
      ]
    },
    {
      id: 3,
      nome: 'Indicadores',
      submenus: [
        { id: 3.1, submenu: 'Informar por Planilha', linkTo: 'indicador/informar-por-planilha', acceptedRoles: PERMISSOES_E_ROTAS['informaIndicador'] },
        { id: 3.2, submenu: 'Ajustar Indicador', linkTo: 'indicador/ajustar', acceptedRoles: PERMISSOES_E_ROTAS['ajustaIndicador'] }
      ]
    },
    {
      id: 4,
      nome: 'Relatório de Acompanhamento',
      submenus: [
        { id: 4.1, submenu: 'Novo', linkTo: 'relatorio-acompanhamento/criar', acceptedRoles: PERMISSOES_E_ROTAS['criaRelAcomp'] },
        { id: 4.2, submenu: 'Download PDF', linkTo: 'relatorio-acompanhamento/download', acceptedRoles: PERMISSOES_E_ROTAS['downloadRelAcomp'] }
      ]
    },
    {
      id: 5,
      nome: 'Pendências',
      submenus: [
        { id: 5.1, submenu: 'Responder', linkTo: 'relatorio-acompanhamento/pendencias/responder', acceptedRoles: PERMISSOES_E_ROTAS['respondePendencia'] }
      ]
    },
    {
      id: 7,
      nome: 'Relatórios',
      submenus: [
        { id: 7.1, submenu: 'Gerar Relatórios', linkTo: 'relatorios/gerar', acceptedRoles: PERMISSOES_E_ROTAS['gerarRelatorios'] }
      ]
    }
  ]
};